export const setPath = (path) => {
    return {
        type: 'SET_PATH',
        path
    }
}


// WEBPACK FOOTER //
// ./src/components/App/AppActions.js